import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  list: {
    marginTop: '0px',
    marginBottom: '0px',
    paddingLeft: '20px',
  },
}));
